import { FilterButtonWithMobileDrawer } from 'components/search/v2/Filter/FilterButtonWithMobileDrawer';
import { useAtom, useSetAtom } from 'jotai';
import {
  captainOptionsTempAtom,
  captainOptionsAtom,
  isCaptainFilterActiveAtom,
  getCaptainOptionsDefault,
  checkedCaptainOptionsLabelAtom,
} from 'components/search/v2/Filter/filterStore';
import CheckboxFilterLabel from 'components/search/v2/Filter/contents/CheckboxFilterLabel';
import CaptainFilterContent from './CaptainFilterContent';

const CaptainFilterButton = (props) => {
  const { toggleFilterDropdown, name } = props;
  const [captainTempOptions, setCaptainTempOptions] = useAtom(captainOptionsTempAtom);
  const setOGCaptainOptions = useSetAtom(captainOptionsAtom);

  const onClear = () => {
    const newOptions = getCaptainOptionsDefault();
    setCaptainTempOptions(newOptions);
  };
  const onShowResults = () => {
    setOGCaptainOptions(captainTempOptions);
    toggleFilterDropdown(null);
  };

  return (
    <FilterButtonWithMobileDrawer
      {...props}
      name={name}
      title="Captain options"
      label={
        <CheckboxFilterLabel
          label="Captain"
          isFilterActiveAtom={isCaptainFilterActiveAtom}
          checkedValuesAtom={checkedCaptainOptionsLabelAtom}
        />
      }
      content={<CaptainFilterContent />}
      onClear={onClear}
      onShowResults={onShowResults}
      isFilterActiveAtom={isCaptainFilterActiveAtom}
      toggleDropdown={toggleFilterDropdown}
      disabled={false}
    />
  );
};

export default CaptainFilterButton;
